import { render, staticRenderFns } from "./ScrollBar.vue?vue&type=template&id=ce8af294&scoped=true&"
import script from "./ScrollBar.vue?vue&type=script&lang=js&"
export * from "./ScrollBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8af294",
  null
  
)

export default component.exports